module.exports = __webpack_public_path__ + "static/jeonghyun.nam-ff28bb52cac06e22d7d83dd62910a29a.png";